import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/dorbin.jpeg";
import emotion from "../../Assets/Projects/piza.jpeg";
import editor from "../../Assets/Projects/android1.png";
import chatify from "../../Assets/Projects/rayka.png";
import suicide from "../../Assets/Projects/non.jpeg";
import bitsOfCode from "../../Assets/Projects/seqadam.png";
import khoz from "../../Assets/Projects/khoz.png";
import crm from "../../Assets/Projects/crm.png";
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Rayka Platform"
              description="RAYKA investment platform designed and developed based on .NET Bootstrap and JavaScript"
              demoLink="https://fraykah.ir/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Seqadam Learning English"
              description="Seqadam Learning English platfrom designed and developed based on .NET Bootstrap and JavaScript"
             
              demoLink="https://seqadam.ir/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="File store"
              description="File store
Designed and developed by Flutter
Laravel panel side
online payment
Protect files
and...."
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="CCTV shop"
              description="CCTV shop
Designed and developed with .NET
Bootstrap, pwa, JavaScript"
               
              demoLink="https://#/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Bread shop"
              description="Bread shop
Designed and developed with .NET
Bootstrap, pwa, JavaScript"
           
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Pizza Shop"
              description="Pizza shop-London
Designed and developed with .NET
Bootstrap, PHP, JavaScript"
               
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={khoz}
              isBlog={false}
              title="Bread shop"
              description="Bread shop
Designed and developed with .NET
Bootstrap, pwa, JavaScript"
           
               demoLink="https://khouzashayer.ir/"
               />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={crm}
              isBlog={false}
              title="crm"
              description="crm
Designed and developed with .NET
Bootstrap, pwa, JavaScript"
           
               demoLink="https://#"
               />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
